<template lang="pug">
  DefaultLayout
    CommonSection(title="История транзакций")
      .b-affiliate-transactions-page
        ._tabs
          AffiliateTabs
        BaseInput._search(v-model="referralFilter" label="Поиск реферала")
        FormBlock._main
          BaseTable._table(:headers="$options.headers" :items="items" v-slot="{ items, headers, sort }")
            ._row(v-for="item in items" :key="item.id")
              ._cell
                router-link(:to="{ name: 'affiliate-referral', params: { referralId: item.user.id } }")
                  UserTile(:user="item.user")
                BaseTableHeaderItem._header(v-bind="headers[0]" @sort="sort")
              ._cell {{ formatDate(item.createdAt) }}
                BaseTableHeaderItem._header(v-bind="headers[1]" @sort="sort")
              ._cell 30%
                BaseTableHeaderItem._header(v-bind="headers[2]" @sort="sort")
              ._cell {{ item.amount / 100 }} ₽
                BaseTableHeaderItem._header(v-bind="headers[3]" @sort="sort")
              ._cell.-bold {{ Math.floor(item.amount * 0.3) / 100 }} ₽
                BaseTableHeaderItem._header(v-bind="headers[4]" @sort="sort")
        FormBlock._aside
          ._aside-header Доступно
          ._aside-value {{ $store.state.auth.user.affiliateBalance / 100 }} ₽
          UiKeyVal(:items="totalStats")
        FormBlock._chart
          ChartBar(v-bind="paymentsStats")
</template>

<script>
import affiliateModel from '@/model/affiliate';
import utils from '@/utils/common';

import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import BaseTable from '@/components/base/BaseTable.vue';
import BaseTableHeaderItem from '@/components/base/BaseTableHeaderItem.vue';
import FormBlock from '@/components/FormBlock.vue';
import UserTile from '@/components/UserTile.vue';
import BaseInput from '@/components/BaseInput.vue';
import AffiliateTabs from '@/components/affiliate/AffiliateTabs.vue';
import UiKeyVal from '@/components/ui/UiKeyVal.vue';
import ChartBar from '@/components/chart/ChartBar.vue';

export default {
  name: 'PersonalAffiliateReferralsPage',
  components: {
    UiKeyVal,
    AffiliateTabs,
    BaseInput,
    UserTile,
    FormBlock,
    DefaultLayout,
    CommonSection,
    BaseTable,
    BaseTableHeaderItem,
    ChartBar,
  },
  headers: [
    { title: 'Реферал', sortFn: (a, b) => `${a.user.name} ${a.user.surname}`.localeCompare(`${b.user.name} ${b.user.surname}`) },
    { title: 'Дата платежа', sortFn: (a, b) => a.createdAt - b.createdAt },
    { title: 'Процент' },
    { title: 'Платеж', sortFn: (a, b) => a.amount - b.amount },
    { title: 'Прибыль', sortFn: (a, b) => a.amount - b.amount },
  ],
  data() {
    return {
      referralFilter: '',
    };
  },
  created() {
    this.$store.dispatch('affiliate/fetch');
  },
  computed: {
    items() {
      return this.$store.getters['affiliate/transactions']
        .filter(
          r => !this.referralFilter
            || r.user.name.toLowerCase().includes(this.referralFilter.toLowerCase())
            || r.user.surname.toLowerCase().includes(this.referralFilter.toLowerCase()),
        );
    },
    totalStats() {
      const sum = this.items.map(p => p.amount).reduce((acc, val) => acc + val, 0) / 100;
      const gain = Math.floor(sum * 0.3);

      return [
        { key: 'Весь заработок', val: `${gain} ₽` },
        { key: 'Все платежи', val: `${sum} ₽` },
      ];
    },
    paymentsStats() { return affiliateModel.buildStats(this.$store.getters['affiliate/transactions'] ?? []); },
  },
  methods: {
    formatDate(date) {
      return utils.convertDateToString(date);
    },
  },
};
</script>

<style scoped lang="scss">
.affiliate-transactions-page {
  display: grid;
  grid-template-columns: 1fr 280px;
  gap: 35px;
  align-items: start;

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  &__cell {
    &--bold {
      font-weight: 500;
    }
  }

  ::v-deep .cell, &__cell {
    text-align: center;
    justify-content: center;

    &:nth-child(1) {
      text-align: left;
      justify-content: flex-start;
    }

    &:nth-child(1) { width: 40%; }
    &:nth-child(2) { width: 15%; }
    &:nth-child(3) { width: 11%; }
    &:nth-child(4) { width: 16%; }
    &:nth-child(5) { width: 18%; }
  }

  &__cell ::v-deep .name {
    color: #33A1FB;
    font-weight: 500;
  }

  &__header {
    display: none;
  }

  &__aside {
    &-header {
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: #1E3147;
    }

    &-value {
      font-weight: 700;
      font-size: 30px;
      line-height: 38px;
      letter-spacing: 0.01em;
      color: #33A1FB;
      margin-bottom: 12px;
    }
  }

  @media (max-width: 1250px) {
    grid-template-columns: 1fr;

    &__tabs {
      grid-column: 1 / 1 span;
      order: 1;
    }

    &__aside {
      order: 2;
    }

    &__search {
      order: 3;
    }

    &__main {
      order: 4;
    }

    &__chart {
      order: 5;
    }
  }

  @media (max-width: 1000px) {
    &__main {
      background: transparent;
      padding: 0;
      box-shadow: none;
    }

    &__header {
      display: flex;
    }

    &__table ::v-deep .header {
      display: none;
    }

    &__table ::v-deep .body {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }

    &__row {
      &, &:nth-child(odd) {
        background: #FFFFFF;
        border-radius: 8px;
        padding: 12px 18px 22px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
      }
    }

    ::v-deep .cell, &__cell {
      width: auto !important;
    }

    &__cell {
      display: flex;
      flex-direction: column-reverse;
      justify-self: flex-start;
      align-items: flex-start;
      gap: 5px;

      &:first-child {
        grid-column: 1 / 2 span;
        padding-bottom: 20px;
        border-bottom: 1px solid #EBEFF2;
        justify-self: stretch;
        gap: 10px;
      }
    }
  }

  @media (max-width: 576px) {
    &__tabs {
      overflow-x: scroll;
    }

    &__table ::v-deep .body {
      grid-template-columns: 1fr;
    }
  }
}
</style>
